import React from 'react';
import { AssetsOwnedEnum } from '@biproxi/models/enums/InvestorProfileAnswersEnums';
import IInvestorProfile from '@biproxi/models/interfaces/IInvestorProfile';
import { IUserGraphQL } from '@biproxi/models/interfaces/IUser';
import RadioList from '../../elements/RadioList';

type ProfileAssetsQuestionProps = {
  user: IUserGraphQL;
  setUserInvestorProfileField: (field: Partial<IInvestorProfile>) => void;
};

const ProfileAssetsQuestion: React.FC<ProfileAssetsQuestionProps> = ({
  user,
  setUserInvestorProfileField,
}) => {
  const config = Object.values(AssetsOwnedEnum).map((item) => ({
    label: item,
    active: user?.investorProfile?.assetsOwned === item,
    onClick: () => setUserInvestorProfileField({ assetsOwned: item }),
  }));

  /* Render */
  return (
    <RadioList
      dataCy="radio-assets"
      title="How many assets do you own or have under management?"
      config={config}
      rowGap="8px 0px"
    />
  );
};

export default ProfileAssetsQuestion;
